export default function NotFoundPage() {
  return (
    <main id="main-content" className="page">
      <div className="card stack" style={{ marginTop: "20vh" }}>
        <h1>Page not found</h1>
        <p>This page doesn't exist. If someone sent you a link, please check it's complete.</p>
      </div>
    </main>
  );
}
